import { MGPFallible } from '@everyboard/lib';
import { MoveWithTwoCoords } from '../../../jscaip/MoveWithTwoCoords';
import { TaflMove } from '../TaflMove';
export class BrandhubMove extends TaflMove {
    static encoder = MoveWithTwoCoords.getFallibleEncoder(BrandhubMove.from);
    static from(start, end) {
        const validity = TaflMove.isValidDirection(start, end);
        if (validity.isFailure()) {
            return validity.toOtherFallible();
        }
        else {
            return MGPFallible.success(new BrandhubMove(start, end));
        }
    }
    getMaximalDistance() {
        return 7;
    }
}
